import React from 'react';
import { Row, Col, Card } from 'reactstrap';
import CodeBlock from '../CodeBlock';

function CvDownloadSection() {
    return (
        <section id="cvdownload">
            <Row>
                <Col>
                    <h3>CV download endpoint (/cv/&#123;id1&#125;,&#123;id2&#125;,&#123;id3&#125;)</h3>
                    <p>
                        <code>GET</code> request to <code>/cv/{`{id}`}</code> returns the following response model.
                    </p>
                    <p>
                        <code>{`{id}`}</code> represents the candidate ID provided in the search result and candidate objects.
                        The endpoint allows a <code>{`,`}</code> delimited list.
                    </p>
                    <p>
                        The file that you get is in zip format. To retrieve cvs you need to unzip it. Zip filenames will follow
                        filename convention: <code>{`CVs-{0:yyyy-MMM-dd-hhmmss}.zip`}.</code>
                    </p>
                    <p>
                        Cvs contained in the zip file will have following naming convention:{' '}
                        {`{candidate_forename} {candidate_surname} ({candidate_id}).{extension}`}.
                    </p>
                    <p>Returns results only for non-anonymous candidates.</p>
                    <Card className="bg-dark text-white" body>
                        <h4>Curl Example</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`curl -X GET \\\n'https://recruiter.totaljobs.com/CandidateSearchApi/cv/123456' \\\n-H 'authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto' \\\n-H 'cache-control: no-cache'`}
                        </CodeBlock>
                        <h4>REQUEST HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`Authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto`}
                        </CodeBlock>
                        <h4>RESPONSE HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: application/zip\nstatus: 200 OK`}
                        </CodeBlock>
                        <h4>RESPONSE BODY</h4>
                        <CodeBlock langauge="json" theme="dark">
                            {`This will be a binary zip file.`}
                        </CodeBlock>
                    </Card>
                </Col>
            </Row>
        </section>
    )
}

export default CvDownloadSection
